<template>
  <v-container class="overview-page">

    <v-row class="ma-0">
      <v-col cols="12">
        <h2 class="primary--text font-weight-bold pt-5 pl-2">
          <v-icon color="primary" large left>filter</v-icon>
          {{ $t('book/admin:parameter.overview.title') }}
        </h2>

        <DataTable
            :enabled-search="true"
            :headers="headers"
            :data="content"
            checkbox-on-property="useValue"
            icon="edit"
            @clickedButton1="editParameter"
            :addBtn="true"
            :addBtnRoute="`/${$store.state.manager.bookModuleUrl}/admin/parameter/edit`"
            :addBtnText="$t('book/admin:parameter.overview.add-btn')"
            sortBy="name"
            @cacheCommit="$store.commit('book/admin/storeParameterOverviewSearch', $event)"
            :cachedSearch="$store.state.book.admin.parameterOverviewSearch"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ParameterService from "../../services/parameter-service";
import DataTable from "../../../core/components/DataTable/DataTable";
import DataUtils from "@/modules/core/services/data-utils";
import Parameter from "../../data/parameter";
import Utils from "../../../core/services/utils";

export default {
  name: "ParameterOverview",
  components: {
    DataTable
  },
  data() {
    return {
      content: []
    }
  },
  methods: {
    editParameter(item) {
      this.$router.push(`/${this.$store.state.manager.bookModuleUrl}/admin/parameter/edit/${item.id}`);
    }
  },
  computed: {
    headers() {
      return [
        {text: "ID", value: 'id'},
        {text: this.$t('common:name'), value: 'name'},
        {text: this.$t('common:type'), value: 'typeName'},
        {text: this.$t('book/admin:parameter.common.sub-type'), value: 'subType'},
        {text: this.$t('book/admin:parameter.overview.datatable.value'), value: 'checkbox', sortable: false},
        {text: this.$t('book/admin:parameter.common.value-type'), value: 'valueType'},
        {text: "", value: "controls", sortable: false}
      ]
    }
  },
  created() {
    ParameterService.readAllFromAPI(
      (resp) => {
        var response = DataUtils.parseDataToObjectArray(resp.data, Parameter);
        if (response == null) {
          this.content = [];
        } else {
          this.content = response;
        }
      },
      (error) => {
        this.$logger.error("Error at getting parameters, because: " + error)
        Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('book/admin:parameter.common.parameter')}))
      }
    )
  }
}
</script>
<style lang="scss">

.wrap-word {
  word-break: break-all;
}

</style>
